<template>
  <v-container fill-height fluid pa-2 class="notes">
    <v-layout style="overflow:hidden;">
      <!-- <d-multi-pane class="fill-height">
        <d-multi-pane-content min-width="440px" max-width="840px"> -->
          <v-flex :lg4="!calendarCollapsed" :md6="!calendarCollapsed" :md12="calendarCollapsed" xs12 class="notes__wrapper" style="padding-top:48px;">
            <NotesHeader ref="notes__header"/>
            <NotesContainer class="notes__container" />
          </v-flex>
          <!-- <div style="border:1px solid red">
            <p></p>
          </div>
        </d-multi-pane-content>
        <d-multi-pane-resizer :line="false"></d-multi-pane-resizer>
        <d-multi-pane-content min-width="680px">
          <CalendarWrapper class="notes__calendarWrapper"/>
        </d-multi-pane-content>
      </d-multi-pane> -->
      <CalendarWrapper class="notes__calendarWrapper"/>
    </v-layout>
  </v-container>
</template>

<script>

// import { DMultiPane, DMultiPaneContent, DMultiPaneResizer } from '@/components/MultiPane'
import store  from './store';
import NotesContainer from './components/notes/NotesContainer';
import CalendarWrapper from './components/CalendarWrapper';
import NotesHeader from './components/notes/NotesHeader';
import './styles/main.scss'


export default {
  name: 'Notes',
  data() {
    return {
      notesFromServer: [],
      allNotesWithEmpty: [],
      loaderForNotes: true,

      currNote: {},
      currNoteDate: '',
      editableNote: {},
      showCalendar: false,

      searchNotes: [],

      readyState: false,
      notesEmpty: false,
      scrolled: false,
      // Структуры календаря
      filledNotes: [],
      calendarNotesHashMap: [],
      // expandCalendar
      calendarCollapsed: false
    };
  },
  components: {
    NotesContainer,
    CalendarWrapper,
    NotesHeader,
    // DMultiPane,
    // DMultiPaneContent,
    // DMultiPaneResizer
  },
  created() {
    this.$store.registerModule('notes', store);
    let is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent); // Проверяем сафари ли
  },
  mounted() {
    this.$bus.$on('expandNotes', status => {
      this.calendarCollapsed = status
    })
  },
  destroyed() {
    this.$bus.$off('expandNotes')
    this.$store.unregisterModule('notes');
    
  }
};
</script>




// WEBPACK FOOTER //
// src/apps/bpm/notes/index.vue